module.exports = __webpack_public_path__ + "media/images/design/images/h2_movies-fdf650c3262e0a5fe1def73d609ef004.png";